import { render, staticRenderFns } from "./GuaranteesTable.vue?vue&type=template&id=001b1520"
import script from "./GuaranteesTable.vue?vue&type=script&lang=js"
export * from "./GuaranteesTable.vue?vue&type=script&lang=js"
import style0 from "./GuaranteesTable.vue?vue&type=style&index=0&id=001b1520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDataTable,VIcon})
